import { useContext } from "react"
import { Redirect, useParams } from "react-router-dom"
import { UserContext } from "../../hooks/UserContext"
import { ROOT } from "../../navigation/constants"
import { getDefaultWorkforceLanding } from "./WorkforceTabs"

export const WorkforceIndexRedirect = () => {
    const { user } = useContext(UserContext)
    const { warehouse_id } = useParams()
    const target = getDefaultWorkforceLanding(user, warehouse_id)
    if (target) return <Redirect to={target} />
    return <Redirect to={ROOT.replace(':warehouse_id', warehouse_id)} />
}
